import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius } from '~styles/theme.stylex';
export const styles = {
  container: {
    maxWidth: "xzsb0xr",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  nav: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "x1qughib",
    paddingBlock: "xgepmj6",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  brand: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    $$css: true
  },
  navCta: {
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    fontWeight: "xlr2uoh",
    fontSize: "x6u19be",
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xnxx81d",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  }
};